import { Step } from "react-joyride";
import {
  ADD_PRODUCT_CONTENT,
  clickElement,
  jobContinueStep,
  LOOK_ONLY,
  mapSteps,
  NO_BACK,
  productSectionSteps,
  selectProductStep,
  totalsAndSendSteps,
  variantStep,
  waitFor,
  waitForSettled,
  withTourDefaults,
} from "./DraftPageTour.shared";

const isPendingJob = () => !!document.querySelector(".tour-job-name");

const openJobAddressMap = async () => {
  if (document.querySelector(".tour-map-address-window")) return;
  clickElement(isPendingJob() ? ".tour-job-address" : ".tour-edit-job-address");
  await waitForSettled(".tour-map-address-window");
};

const openAddProductDrawer = async () => {
  if (document.querySelector(".tour-select-product")) return;
  clickElement(".tour-add-product-button");
  await waitForSettled(".tour-select-product");
};

// Closes the Add Product drawer (if still open) and makes sure the first job and one of its
// products are expanded, so the product section is on screen.
const showExpandedProduct = async () => {
  clickElement(".tour-add-product-drawer-close");
  if (document.querySelector(".tour-measure-job")) return;

  const header = document.querySelector<HTMLElement>(".tour-stage-header-toggle");
  if (header?.dataset.expanded === "false") {
    header.click();
    await waitFor(".tour-product-expand", 2000);
  }
  if (document.querySelector(".tour-measure-job")) return;

  clickElement(".tour-product-expand");
  await waitFor(".tour-measure-job", 2000);
};

const steps: Step[] = [
  variantStep(
    "job-name",
    isPendingJob,
    { target: ".tour-job-name", content: "Give your job a name." },
    { target: ".tour-edit-job-name", content: "Click the edit icon to change your job name." },
    {
      data: { requireValue: ".tour-job-name input" },
      disableFocusTrap: true,
      ...NO_BACK,
    }
  ),
  variantStep(
    "job-address",
    isPendingJob,
    {
      target: ".tour-job-address",
      content: "Click here to open Maps and add an address to your Job/Stage.",
    },
    {
      target: ".tour-edit-job-address",
      content: "Click the edit icon to open Maps and change the address of your Job/Stage.",
    },
    LOOK_ONLY
  ),
  ...mapSteps(openJobAddressMap),
  // Only shown for a job that was not saved yet; skipped otherwise.
  { ...jobContinueStep, targetWaitTimeout: 1000 },
  { ...selectProductStep, before: openAddProductDrawer },
  {
    id: "add-product",
    target: ".tour-add-product-to-proposal",
    content: ADD_PRODUCT_CONTENT,
    ...LOOK_ONLY,
  },
  ...productSectionSteps({ before: showExpandedProduct, targetWaitTimeout: 3000 }),
  ...totalsAndSendSteps,
];

const proposalsDraftPageTourSteps: Step[] = withTourDefaults(steps);

export default proposalsDraftPageTourSteps;
